<template>
  <div class="main">
    <Loading v-if="Loading" />
    <Modal
      v-if="showModal"
      :modalMessage="modalMessage"
      @close-modal="closeModal"
    />
    <UserAlreadyDeliveringModal
      v-if="showModal"
      :modalMessage="modalMessage"
      @close-modal="redirectToDashboard"
    />
    <OrderModal
      v-if="showingOrderDetails"
      :orderDetails="orderToBeShown"
      @close-order-modal="closeOrderDetails"
      @accepting-own-order="acceptingOwnOrder"
    />
    <div v-if="!Loading" class="container">
      <p>Orders</p>
      <h6>
        <i
          >(This Page Refreshes Every 30 Seconds) <br />
          Refreshing in {{ thirtySeconds }} Seconds</i
        >
      </h6>
      <div class="order-list" v-if="areThereOrders">
        <OrderList
          v-for="order in orders"
          :key="order.orderId"
          :orderDetails="order"
          @showOrderDetails="showOrderWhenClicked"
          @acceptOrder="acceptOrder"
        />
      </div>
      <div class="no-order-to-show" v-else>
        <p>Everybody Has Been Saved! Thank You For Saving Savours!</p>
        <img src="../assets/memeImages/EveryoneSaved.jpeg" alt="" />
      </div>

      <!--
        Add a div incase there are no orders to show, that is all are accepted
        -->
    </div>
  </div>
</template>

<script>
import Loading from "../components/Loading.vue";
import OrderModal from "../components/OrderModal.vue";
import OrderList from "../components/OrderList.vue";
import Modal from "../components/Modal.vue";
import UserAlreadyDeliveringModal from "../components/Modal.vue";
//import firebase from "firebase/app";
import db from "../firebase/firebaseInit";
import "firebase/auth";
import firebase from "firebase/app";

export default {
  name: "FetchOrder",
  components: {
    OrderModal,
    OrderList,
    Loading,
    Modal,
    UserAlreadyDeliveringModal,
  },
  data() {
    return {
      orders: null,
      showingOrderDetails: false,
      orderToBeShown: null,
      Loading: true,
      fetchOrderTimer: null,
      modalMessage: null,
      showModal: false,
      thirtySeconds: 30,
      areThereOrders: false,
    };
  },
  async created() {
    const dataBase = await db
      .collection("users")
      .doc(firebase.auth().currentUser.uid);
    const dbResults = await dataBase.get();

    if (dbResults.data().delivering) {
      this.modalMessage = "You Are Already Saving Somebody!";
      this.Loading = false;
      this.showModal = true;
      return;
    }
    //fetch all the orders data from firebase
    await db
      .collection("orders")
      .orderBy("orderTime", "desc")
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          console.log(
            doc.id,
            "<=Data Id Fetched one Order DATA =>",
            doc.data()
          );
          if (!doc.data().acceptedBySaviour && !doc.data().cancelled) {
            this.orders.push({ orderId: doc.id, ...doc.data() });
          }
        });
        this.Loading = false;
      });

    this.areThereOrders = true;

    if (this.orders.length === 0 || !this.orders) {
      this.areThereOrders = false;
    }

    this.fetchRecentOrders();

    // this.orders = this.$store.dispatch("getOrderDetails");
    // console.log("OrderS:", this.orders);
  },
  mounted() {
    this.orders = this.$store.state.orders;
  },
  props: {},
  beforeDestroy() {
    clearInterval(this.fetchOrderTimer);
  },
  methods: {
    closeModal() {
      this.showModal = false;
    },
    redirectToDashboard() {
      this.$router.push({ name: "Dashboard" });
    },
    fetchRecentOrders() {
      this.fetchOrderTimer = setInterval(() => {
        if (this.thirtySeconds === 0) {
          this.$router.go();
        } else {
          this.thirtySeconds--;
        }
      }, 1000);
    },
    closeOrderDetails() {
      this.showingOrderDetails = !this.showingOrderDetails;
    },
    showOrderWhenClicked(order) {
      this.orderToBeShown = order;
      this.showingOrderDetails = !this.showingOrderDetails;
    },
    acceptingOwnOrder() {
      this.showingOrderDetails = false;
      this.modalMessage = "Surprise! You Cannot Accept Your Own Order ;)";
      this.showModal = true;
    },
    acceptOrder(theOrder) {
      if (this.$store.state.profileId === theOrder.userid) {
        this.acceptingOwnOrder();
        console.log("Cannot Accept Your Own Order!");
        return;
      }
      this.$router.push({
        name: "ConfirmAndAccept",
        params: {
          orderDetails: theOrder,
          orderId: theOrder.orderId,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.main {
  display: flex;
  justify-content: center;
  //background: url("../assets/background/background20.jpg");
  //background-repeat: no-repeat;
  //background-size: cover;
  //height: 100vh;

  .container {
    width: 100vw;
    //background-color: aqua;
    background-color: #fff;
    //background: rgba(0, 0, 0, 0.5);
    //margin: 50px 0;
    overflow: scroll;
    //height: 80%;

    .no-order-to-show {
      img {
        margin: 0 auto 10px auto;
        height: 60%;
        width: 60%;
        border-radius: 8px;
      }
    }

    p {
      margin-top: 20px;
      text-align: center;
      font-size: 40px;
    }

    h1 {
      text-align: center;
      margin: 30px 0;
    }

    h6 {
      padding: 1px 10px;
    }
  }

  ul {
    position: relative;
    margin: auto 0;
    padding: 10px;
    box-sizing: border-box;
  }

  ul li {
    display: flex;
    background: rgba(255, 255, 255, 0.1);
    color: rgb(0, 0, 0);
    margin: 5px 0;
    transition: 0.5s;
    border: 5px;
  }

  .box {
    font-size: 30px;
    user-select: none;
    cursor: pointer;
    position: relative;
    min-width: 500px;
    background: rgb(0, 255, 55);
    //background: #fff;
    margin: 0.2em;
    float: inline-start;
    box-sizing: border-box;
    overflow: hidden;
    border-radius: 10px;
    padding: 10px;
  }
}
</style>
